// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#company-description {
    background-color: #ffffff;
    padding: 4rem 0;
}

.description-section {
    align-items: start;
    width: 100%;
    margin: 2rem auto;
    flex-wrap: wrap;
}

.description-section-logo {
    width: 100%;
    padding: 3rem 2rem;
    margin: 6rem 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: .5rem;
}

.description-section-logo img {
    width: 100%;
}

.description-section-info {
    /* background-color: #Adadb9; */
    /* padding: 0 2rem; */
    width: 100%;
    text-align: center;
    /* margin: 2rem 0; */
}

.description-section-info h1 {
    /* line-height: 2.5rem; */
    margin-top: 3rem;
    margin-bottom: 2rem;
}

.description-section-info h3 {
    line-height: 2.5rem;
}

.description-section-logo-link {
    width: 100%;
}

@media screen and (min-width: 768px) {
    #company-description {
        padding: 8rem 0;
    }

    .description-section {
        flex-wrap: nowrap;
        margin: 6rem auto;
    }

    .description-section-logo {
        padding: 4rem 2rem;
        margin: 0 2rem 0 0;
        /* height: 20rem; */
        width: 40%;
        max-width: 600px;
        /* height: fit-content; */
        aspect-ratio: inherit;
        flex-grow: 0;
    }

    .description-section-logo-link {
        width: 100%;
    }

    .description-section-info {
        padding: 0 2rem;
        width: 50%;
        text-align: left;
    }

    .description-section-info h1 {
        margin-top: 0;
    }

    .description-section-info h3 {
        line-height: 2.5rem;
    }

    .description-section-info button {
        margin-top: 2rem;
    }   
}`, "",{"version":3,"sources":["webpack://./components/CompanyDescriptionContainer/CompanyDescriptionContainer.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,UAAU;QACV,gBAAgB;QAChB,yBAAyB;QACzB,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["#company-description {\n    background-color: #ffffff;\n    padding: 4rem 0;\n}\n\n.description-section {\n    align-items: start;\n    width: 100%;\n    margin: 2rem auto;\n    flex-wrap: wrap;\n}\n\n.description-section-logo {\n    width: 100%;\n    padding: 3rem 2rem;\n    margin: 6rem 0 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: .5rem;\n}\n\n.description-section-logo img {\n    width: 100%;\n}\n\n.description-section-info {\n    /* background-color: #Adadb9; */\n    /* padding: 0 2rem; */\n    width: 100%;\n    text-align: center;\n    /* margin: 2rem 0; */\n}\n\n.description-section-info h1 {\n    /* line-height: 2.5rem; */\n    margin-top: 3rem;\n    margin-bottom: 2rem;\n}\n\n.description-section-info h3 {\n    line-height: 2.5rem;\n}\n\n.description-section-logo-link {\n    width: 100%;\n}\n\n@media screen and (min-width: 768px) {\n    #company-description {\n        padding: 8rem 0;\n    }\n\n    .description-section {\n        flex-wrap: nowrap;\n        margin: 6rem auto;\n    }\n\n    .description-section-logo {\n        padding: 4rem 2rem;\n        margin: 0 2rem 0 0;\n        /* height: 20rem; */\n        width: 40%;\n        max-width: 600px;\n        /* height: fit-content; */\n        aspect-ratio: inherit;\n        flex-grow: 0;\n    }\n\n    .description-section-logo-link {\n        width: 100%;\n    }\n\n    .description-section-info {\n        padding: 0 2rem;\n        width: 50%;\n        text-align: left;\n    }\n\n    .description-section-info h1 {\n        margin-top: 0;\n    }\n\n    .description-section-info h3 {\n        line-height: 2.5rem;\n    }\n\n    .description-section-info button {\n        margin-top: 2rem;\n    }   \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
